const errorEndpoints = {
  postErrorEvent: {
    method: "POST",
    path: "/errors",
  },
  getErrorIssues: {
    method: "GET",
    path: "/errors/issues",
  },
  getErrorIssue: (issueId) => ({
    method: "GET",
    path: `/errors/issues/${issueId}`,
  }),
  updateErrorIssueStatus: (issueId) => ({
    method: "PATCH",
    path: `/errors/issues/${issueId}/status`,
  }),
  getErrorEvents: {
    method: "GET",
    path: "/errors/events",
  },
  getErrorEvent: (eventId) => ({
    method: "GET",
    path: `/errors/events/${eventId}`,
  }),
  updateErrorEventStatus: (eventId) => ({
    method: "PATCH",
    path: `/errors/events/${eventId}/status`,
  }),
};

export default errorEndpoints;
